enum PaymentFieldType {
    cardholdername,
    number,
    cardexpiry,
    cvv,
    cardholdercountry,
    cardholderaddress,
    cardholdercity,
    cardholderpostalcode
}

export default PaymentFieldType;
